import React from 'react';

const MainImageCard = ({ imgPath, title, wrapClass, cardId, imgClass, titleClass }) => {

  return (
    <div className={wrapClass} id={cardId}>
      <div className={imgClass}>
        <img className={imgClass} src={imgPath} />
      </div>
      <div className={titleClass}>
        {title}
      </div>
    </div>
  );
}

export default MainImageCard;
